import { useNavigate } from "react-router-dom";

import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";

interface TikTokConnectedProps {
  show: boolean;
  onHide(): void;
}

export function TikTokConnected({ show, onHide }: TikTokConnectedProps) {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate({
      search: ``,
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title>Your TikTok account has been authorised!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          No changes to upcoming scheduled posts will occur, you will continue
          to receive notifications at time of publish. <br />
          If you would like these posts to be automatically published, you will
          have to edit the posts, and turn the notification post switch off.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={handleClose}>
          Close
        </Button>
        <Button primary size={FormSize.large} onClick={handleClose}>
          I understand
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
